import { Button, Checkbox, Form, Input, Select } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import "./styles.css";
import Eligibility from "./eligibility";
import { BorrowerService } from "../../utils/apiService";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
const AddGovtLoan = () => {
  const [loading, setLoading] = useState(true);
  const [borrowers, setBorrowers] = useState([]);
  const [govt, setGovt] = useState({});
  const token = localStorage.getItem("token");

  const { Option } = Select;

  const [loan, setLoan] = useState({
    client_name: "",
    loan_amount: 0,
    tenure: 0,
    interest: 0,
    processing_fee: 0,
    amount_received: 0,
    monthly_repayment: 0,
    total_loan: 0,
    decision: "",
  });
  const onFinish = (values) => {
    const {
      client_name,
      loan_amount,
      tenure,
      basic_pay,
      deductions,
      allowances,
    } = values;

    //Interest = ((20%*loan_amount) + ((6.5%*loan_amount)*(tenure-1)))
    const interest =
      govt?.interest_1 * loan_amount +
      govt.interest_2 * loan_amount * (tenure - 1);

    //Processing fee : =10%*loan amount
    const processing_fee = loan_amount * govt?.processing_fee_rate;

    //Amount received = loan amount - processing fee
    const amount_received = loan_amount - processing_fee;

    //Monthly repayment = (loan amount + interest) / tenure
    const monthly_repayment =
      (parseFloat(loan_amount) + parseFloat(interest)) / tenure;

    //Total loan = monthly_repayment * tenure
    const total_loan = monthly_repayment * tenure;

    // Sum all allowances
    const total_allowances =
      allowances && allowances.length > 0
        ? allowances.reduce((total, allowance) => {
            const parsedAllowance = parseFloat(allowance) || 0;
            return total + parsedAllowance;
          }, 0)
        : 0;

    //deduction ceiling = 60% of basic pay
    const deduction_ceiling = basic_pay * 0.6;

    // total deduc = deduction ceiling + total allowances
    const total_deduc = deduction_ceiling + total_allowances;

    // balance = total_deduc - deductions
    const balance = total_deduc - deductions;

    // =IF(H18<=$'GRZ LOAN TERM LOANS'.G15,"REJECT","APPROVE")
    const decision = balance <= monthly_repayment ? "Rejected" : "Approved";

    setLoan({
      client_name,
      loan_amount,
      tenure,
      interest,
      processing_fee,
      amount_received,
      monthly_repayment,
      total_loan,
      decision,
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 17 },
    },
  };

  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 17, offset: 7 },
    },
  };

  const fetchBorrowers = async () => {
    try {
      const data = await BorrowerService.fetchGovtBorrowers(token);
      const people = data.map((item) => ({
        label: item.first_name + " " + item.last_name,
        value: item.id,
      }));

      console.log(people);
      setBorrowers(people);
    } catch (error) {
      // Handle error state here
    }
  };

  const fetchGovtLoanType = async () => {
    try {
      const response = await axios.get(
        "https://zedlenders.pickmesms.com/items/govt_loan_type",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setGovt(response.data.data);
    } catch (error) {
      console.error("Error fetching singleton:", error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchBorrowers();
        await fetchGovtLoanType();
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        // Once both calls are done (successfully or with error),
        // set loading to false
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div>
        <div className="col-md-6">
          <div style={{ borderColor: "#36454F" }} className="box">
            <div className="box-header with-border">
              <h3
                id="form"
                className="box-title"
                style={{ marginBottom: "40px" }}
              >
                Payslip Information
              </h3>
              <div>
                <Form
                  name="basic"
                  labelCol={{
                    span: 7,
                  }}
                  layout="horizontal"
                  wrapperCol={{
                    span: 17,
                  }}
                  initialValues={{
                    remember: false,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Borrower"
                    name="client_name"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select a borrower"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      loading={loading}
                    >
                      {borrowers.map((borrower) => (
                        <Select.Option
                          key={borrower.value}
                          value={borrower.value}
                        >
                          {`${borrower.label}  ~ Rating : Not Rated`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Amount Requested: "
                    name="loan_amount"
                    rules={[
                      {
                        required: true,
                        message: "Please input loan amount!",
                      },
                    ]}
                  >
                    <Input placeholder="Amount Requested" type="number" />
                  </Form.Item>

                  <Form.Item
                    label="Tenure:"
                    name="tenure"
                    rules={[
                      {
                        required: true,
                        message: "Please input loan tenure!",
                      },
                    ]}
                  >
                    <Input placeholder="Tenure" type="number" />
                  </Form.Item>

                  <Form.Item
                    label="Basic Pay:"
                    name="basic_pay"
                    rules={[
                      {
                        required: true,
                        message: "Please input basic pay!",
                      },
                    ]}
                  >
                    <Input placeholder="Basic pay" type="number" />
                  </Form.Item>

                  <Form.Item
                    label="Deductions (-):"
                    name="deductions"
                    rules={[
                      {
                        required: true,
                        message: "Please input deductions or enter 0!",
                      },
                    ]}
                  >
                    <Input placeholder="Deductions" type="number" />
                  </Form.Item>

                  <Form.List name="allowances">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field, index) => (
                          <Form.Item
                            {...(index === 0
                              ? formItemLayout
                              : formItemLayoutWithOutLabel)}
                            label={index === 0 ? "Allowances (999)" : ""}
                            required={false}
                            key={field.key}
                          >
                            <Form.Item
                              {...field}
                              validateTrigger={["onChange", "onBlur"]}
                              rules={[
                                {
                                  required: false,
                                  whitespace: true,
                                  message:
                                    "Please input allowance or delete this field.",
                                },
                              ]}
                              noStyle
                            >
                              <Input
                                placeholder="Allowance"
                                type="number"
                                style={{ width: "60%" }}
                              />
                            </Form.Item>
                            {fields.length > 1 ? (
                              <MinusCircleOutlined
                                className="dynamic-delete-button"
                                style={{ margin: "0 8px" }}
                                onClick={() => remove(field.name)}
                              />
                            ) : null}
                          </Form.Item>
                        ))}
                        <Form.Item {...formItemLayoutWithOutLabel}>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            style={{ width: "60%" }}
                            icon={<PlusOutlined />}
                          >
                            Add Allowance
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <Form.Item
                    wrapperCol={{
                      offset: 7,
                      span: 8,
                    }}
                  >
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <Eligibility loan={loan} />
        </div>
      </div>
    </>
  );
};

export default AddGovtLoan;
